import { defineCommand } from '../../../concepts/commands/CommandDefinition';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { ObjectManager } from '../../../concepts/objects';
import { lockSetLayoutIfNotLocked } from '../commands/ComponentCommands';
import { EditorModeInfo } from '../EditorModeInfo';
import { EditorSession } from '../EditorSession';
import { MyRoleInfo } from '../MyRoleInfo';
import { meetingStart } from './MeetingCommands';
import { MeetingMode } from './MeetingMode';
import { resolveActiveMeeting } from './MeetingUtil';

export const switchToMeetingMode = defineCommand(
    'switchToMeetingMode',
    'Switch To: Meeting Mode',
    async r => {

        const dispatch = r.call(CommandDispatcher);
        const objects = r.call(ObjectManager);
        const session = r.call(EditorSession);
        const { canManage } = session.get(MyRoleInfo);

        const currentUrl = window.location.href;
        const urlString = currentUrl.substring(currentUrl.lastIndexOf('/') + 1);
        const tutorial = urlString === 'tutorials-participant';

        // If no meeting active, start a meeting first...
        if (canManage && !resolveActiveMeeting(objects)) {
            await dispatch(meetingStart, tutorial);
            await dispatch(lockSetLayoutIfNotLocked);
        }

        session.update(EditorModeInfo, MeetingMode);
    }
);
